<template>
  <div v-if="showPage" class="app_page" id="app">
    <div v-if="this.$route.name != 'ProjectsResult'">
      <div v-if="isLogin" class="page_box">
        <Menuitem>
        </Menuitem>
        <div class="page_main">
          <breadcrumb></breadcrumb>
          <div class="page_cell">
            <router-view />
          </div>
        </div>
      </div>
      <Login v-else></Login>
    </div>
    <div v-else class="page_box">
      <div class="page_main">
        <div class="page_cell">
          <router-view />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import port from './api/port.js';
import Login from './components/Login.vue';
import Menuitem from './components/Menuitem.vue';
import Breadcrumb from './components/Breadcrumb.vue';

export default {
  components: {
    Login,
    Menuitem,
    Breadcrumb
  },

  data() {
    return {
      isLogin: true,
      showPage: true,
      interval: 30 * 60 * 1000,//每30分钟轮询一次token
      // interval: 40 * 1000,//每20s轮询一次token
    }
  },
  created() {
    if (localStorage.getItem('xthy_admin_token')) {
      this.getInit()
    } else {
      this.isLogin = false
    }
  },
  methods: {
    getInit() {
      var that = this
      that.isLogin = true
      that.timer = setTimeout(function () {
        that.getRefreshLogin()
      }, that.interval)
    },
    getRefreshLogin() {
      var that = this
      port.getRefreshLogin({}).then(res => {
        if (res.state == 1) {
          localStorage.setItem('xthy_admin_token', res.data.access_token)
          localStorage.setItem('xthy_admin_manager_info', JSON.stringify(res.data.manager))
          that.timer = setTimeout(function () {
            that.getRefreshLogin()
          }, that.interval)
        } else {
          that.$message({
            message: res.error[0],
            type: 'error'
          });
        }
      })
    },
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
}

.page_box {
  display: flex;
  overflow: hidden;

  .page_main {
    min-width: 1000px;
    flex: 1;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.page_cell {
  padding: 15px 20px;
}

.c-gray {
  color: #999999 !important;
}

.c-green {
  color: #67c23a !important;
}

.c-orange {
  color: #E6A23C !important;
}

.c-red {
  color: #f50505 !important;
}

.c-blue {
  color: #409EFF !important;
}

.f-12 {
  font-size: 12px;
}

.f-13 {
  font-size: 13px;
}

.f-14 {
  font-size: 14px;
}

.f-15 {
  font-size: 15px;
}

.f-16 {
  font-size: 16px;
}

.f-17 {
  font-size: 17px;
}

.f-18 {
  font-size: 18px;
}

.f-20 {
  font-size: 20px;
}

.f-w {
  font-weight: bold;
}

.mt-5 {
  margin-top: 5px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.ml-5 {
  margin-left: 5px;
}

.ml-10 {
  margin-left: 10px;
}

.ml-15 {
  margin-left: 15px;
}

.mr-5 {
  margin-right: 5px;
}

.mr-10 {
  margin-right: 10px;
}

.mr-15 {
  margin-right: 15px;
}

.text-c {
  text-align: center;
}

.text-r {
  text-align: right;
}

.text-l {
  text-align: left;
}

.flex-1 {
  flex: 1;
}

.display_flex {
  display: flex;
  align-items: center;
}

.display_a {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.display_b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.display_c {
  display: flex;
  align-items: center;
  justify-content: center;
}

.public_btn {
  border-radius: 4px;
  cursor: pointer;
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  letter-spacing: .02em;
  line-height: 42px;
  text-align: center;
  color: #fff;
  background-color: #1664ff;
}

.btn_disabled {
  background: linear-gradient(54.69deg, rgba(22, 100, 255, .3) 32.77%, rgba(109, 159, 255, .3) 93.5%) !important;
}

.ordinary_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  height: 32px;
  padding: 0 20px;
  line-height: 1.2;
  color: #fff;
  background-color: #1664ff;
}

.btn_green {
  background-color: #85CE61 !important;
}

.el-pagination {
  float: right;
  margin-top: 20px;
  padding-bottom: 30px !important;
}

// 产品规格
.gg_box {
  .gg_cell {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    white-space: nowrap;
  }

  .delBtn {
    color: #ff0000;
    font-size: 12px;
    margin-left: 15px;
    cursor: pointer;
  }
}

.el-textarea__inner {
  font-family: auto;
}

// 产品规格
</style>
